import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-submenu-art',
  templateUrl: './submenu-art.component.html',
  styleUrls: ['./submenu-art.component.scss']
})
export class SubmenuArtComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
